import { CoreStorageEnum } from 'src/app/models/core-storage.enum';

export enum AppStorageEnum {
  storeLanguage = 'user_language',
  country = 'country',
  countries = 'countries',
  boUser = 'username',
}

export type StorageEnum = AppStorageEnum | CoreStorageEnum;
